export const REGIONES = [
  { value: "metropolitana", label: "REGIÓN METROPOLITANA" },
  { value: "valparaiso", label: "REGIÓN DE VALPARAÍSO" },
  { value: "biobio", label: "REGIÓN DEL BIOBÍO" },
  { value: "araucania", label: "REGIÓN DE LA ARAUCANÍA" },
];

export const COMUNAS = [
  { value: "macul", label: "MACUL" },
  { value: "las-condes", label: "LAS CONDES" },
  { value: "providencia", label: "PROVIDENCIA" },
  { value: "santiago", label: "SANTIAGO" },
];

export const NACIONALIDADES = [
  { value: "chilena", label: "CHILENA" },
  { value: "argentina", label: "ARGENTINA" },
  { value: "peruana", label: "PERUANA" },
  { value: "boliviana", label: "BOLIVIANA" },
];

export const ESTADOS_CIVILES = [
  { value: "soltero", label: "SOLTERO" },
  { value: "casado", label: "CASADO" },
  { value: "divorciado", label: "DIVORCIADO" },
  { value: "viudo", label: "VIUDO" },
];

export const GENEROS = [
  { value: "masculino", label: "MASCULINO" },
  { value: "femenino", label: "FEMENINO" },
  { value: "otro", label: "OTRO" },
];

export const DIAS_PAGO = [
  { value: "02", label: "02" },
  { value: "05", label: "05" },
  { value: "08", label: "08" },
  { value: "17", label: "17" },
];

export const ESTADO_CUENTA_OPTIONS = [
  { value: "email", label: "EMAIL" },
  { value: "correo-fisico", label: "CORREO FÍSICO" },
  { value: "ambos", label: "AMBOS" },
];
